import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = { class: "space-y-6 pt-8 sm:space-y-5 sm:pt-10" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Contract Details")
], -1);
const _hoisted_5 = { class: "space-y-6 sm:space-y-5" };
const _hoisted_6 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2" }, "Active", -1);
const _hoisted_8 = { class: "mt-4" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("legend", { class: "sr-only" }, "Contract Active Status", -1);
const _hoisted_10 = { class: "mr-2 flex flex-row align-center" };
const _hoisted_11 = ["id", "value", "name", "checked"];
const _hoisted_12 = ["for"];
const _hoisted_13 = {
    for: "first-name",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
};
const _hoisted_14 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_15 = ["id", "onUpdate:modelValue", "type", "name", "disabled", "onBlur"];
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "text-red-600" };
const _hoisted_18 = { class: "pt-5" };
const _hoisted_19 = { class: "flex justify-end" };
const _hoisted_20 = ["disabled"];
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContractForm',
    props: {
        contractTypeId: {},
        contractType: {},
        selectedContract: {}
    },
    emits: ["cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const formData = reactive({
            LKStatus: true,
            ID: '',
            Contract: '',
            ContractName: '',
            ContractLevel: '',
            ContractSubLevel: '',
            PotentialPositionCategories: '',
            CoveringLetter: '',
            ContractPosition: '',
            GDFSUEZWorkerType: '',
            PensionScheme: '',
            PensionMaxEE: '',
            PensionMaxER: '',
            PensionRule: '',
            PensionMaxEarningsCap: '',
            LifeCover: '',
            PMI: '',
            Car: '',
            CarAllowance: '',
            Bonus: '',
            OvertimeEligibility: '',
            OvertimeNote: '',
            Holidays: '',
            HolidaysCarryOver: '',
            ProbationPeriod: '',
            ASRReviewDate: '',
            HoursofWork: '',
            Sickness: '',
            NoticePeriod: '',
            PostEmploymentRestrictionsNotwithin3monthofleaving: '',
            PostEmploymentRestrictionsNotwithin6mthofleaving: '',
            PostEmploymentRestrictionsNotwithin9mthofleaving: '',
            ExampleTitles1: '',
            ContractTitle: '',
            Security: '',
            GeneralContracts: '',
            ContractType: props.contractType || '',
        });
        const fields = [
            {
                key: 'ID',
                label: 'ID',
                type: 'text',
                name: 'id-field',
                id: 'id-field',
            },
            {
                key: 'ContractTitle',
                label: 'Contract Title',
                type: 'text',
                name: 'ContractTitle-field',
                id: 'ContractTitle-field',
            },
            {
                key: 'Contract',
                label: 'Contract',
                type: 'text',
                name: 'contract-field',
                id: 'contract-field',
            },
            {
                key: 'ContractName',
                label: 'Contract Name',
                type: 'text',
                name: 'contract-name-field',
                id: 'contract-name-field',
            },
            {
                key: 'ContractLevel',
                label: 'Contract Level',
                type: 'text',
                name: 'contract-level-field',
                id: 'contract-level-field',
            },
            {
                key: 'ContractSubLevel',
                label: 'Contract Sub Level',
                type: 'text',
                name: 'contract-sublevel-field',
                id: 'contract-sublevel-field',
            },
            {
                key: 'PotentialPositionCategories',
                label: 'Potential Position Categories',
                type: 'text',
                name: 'ppg-field',
                id: 'ppg-field',
            },
            {
                key: 'CoveringLetter',
                label: 'Covering Letter',
                type: 'text',
                name: 'CoveringLetter-field',
                id: 'CoveringLetter-field',
            },
            {
                key: 'ContractPosition',
                label: 'Contract Position',
                type: 'text',
                name: 'CoveringLetter-field',
                id: 'CoveringLetter-field',
            },
            {
                key: 'GDFSUEZWorkerType',
                label: 'GDF SUEZ Worker Type',
                type: 'text',
                name: 'GDFSUEZWorkerType-field',
                id: 'GDFSUEZWorkerType-field',
            },
            {
                key: 'PensionScheme',
                label: 'Pension Scheme',
                type: 'text',
                name: 'PensionScheme-field',
                id: 'PensionScheme-field',
            },
            {
                key: 'PensionMaxEE',
                label: 'Pension Max EE',
                type: 'text',
                name: 'PensionMaxEE-field',
                id: 'PensionMaxEE-field',
            },
            {
                key: 'PensionMaxER',
                label: 'Pension Max ER',
                type: 'text',
                name: 'PensionMaxER-field',
                id: 'PensionMaxER-field',
            },
            {
                key: 'PensionRule',
                label: 'Pension Rule',
                type: 'text',
                name: 'PensionRule-field',
                id: 'PensionRule-field',
            },
            {
                key: 'PensionMaxEarningsCap',
                label: 'Pension Max Earnings Cap',
                type: 'text',
                name: 'PensionMaxEarningsCap-field',
                id: 'PensionMaxEarningsCap-field',
            },
            {
                key: 'LifeCover',
                label: 'Life Cover',
                type: 'text',
                name: 'LifeCover-field',
                id: 'LifeCover-field',
            },
            {
                key: 'PMI',
                label: 'Private Medical Insurance',
                type: 'text',
                name: 'PMI-field',
                id: 'PMI-field',
            },
            {
                key: 'Car',
                label: 'Car',
                type: 'text',
                name: 'Car-field',
                id: 'Car-field',
            },
            {
                key: 'CarAllowance',
                label: 'Car Allowance',
                type: 'text',
                name: 'CarAllowance-field',
                id: 'CarAllowance-field',
            },
            {
                key: 'Bonus',
                label: 'Bonus',
                type: 'text',
                name: 'Bonus-field',
                id: 'Bonus-field',
            },
            {
                key: 'OvertimeEligibility',
                label: 'Overtime Eligibility',
                type: 'text',
                name: 'OvertimeEligibility-field',
                id: 'OvertimeEligibility-field',
            },
            {
                key: 'OvertimeNote',
                label: 'Car',
                type: 'text',
                name: 'Car-field',
                id: 'Car-field',
            },
            {
                key: 'Holidays',
                label: 'Holidays',
                type: 'text',
                name: 'Holidays-field',
                id: 'Holidays-field',
            },
            {
                key: 'HolidaysCarryOver',
                label: 'Holidays Carry Over',
                type: 'text',
                name: 'HolidaysCarryOver-field',
                id: 'HolidaysCarryOver-field',
            },
            {
                key: 'ProbationPeriod',
                label: 'Probation Period',
                type: 'text',
                name: 'ProbationPeriod-field',
                id: 'ProbationPeriod-field',
            },
            {
                key: 'ASRReviewDate',
                label: 'ASR Review Date',
                type: 'text',
                name: 'ASRReviewDate-field',
                id: 'ASRReviewDate-field',
            },
            {
                key: 'HoursofWork',
                label: 'Hours of Work',
                type: 'text',
                name: 'HoursofWork-field',
                id: 'HoursofWork-field',
            },
            {
                key: 'Sickness',
                label: 'Sickness',
                type: 'text',
                name: 'Sickness-field',
                id: 'Sickness-field',
            },
            {
                key: 'NoticePeriod',
                label: 'Notice Period',
                type: 'text',
                name: 'NoticePeriod-field',
                id: 'NoticePeriod-field',
            },
            {
                key: 'PostEmploymentRestrictionsNotwithin3monthofleaving',
                label: 'Post Employment Restrictions Not within 3 months of leaving',
                type: 'text',
                name: 'PostEmploymentRestrictionsNotwithin3monthofleaving-field',
                id: 'PostEmploymentRestrictionsNotwithin3monthofleaving-field',
            },
            {
                key: 'PostEmploymentRestrictionsNotwithin6mthofleaving',
                label: 'Post Employment Restrictions Not within 6 months of leaving',
                type: 'text',
                name: 'PostEmploymentRestrictionsNotwithin6mthofleaving-field',
                id: 'PostEmploymentRestrictionsNotwithin6mthofleaving-field',
            },
            {
                key: 'PostEmploymentRestrictionsNotwithin9mthofleaving',
                label: 'Post Employment Restrictions Not within 9 months of leaving',
                type: 'text',
                name: 'PostEmploymentRestrictionsNotwithin9mthofleaving-field',
                id: 'PostEmploymentRestrictionsNotwithin9mthofleaving-field',
            },
            {
                key: 'ExampleTitles1',
                label: 'Example Titles',
                type: 'text',
                name: 'ExampleTitles1-field',
                id: 'ExampleTitles1-field',
            },
            {
                key: 'Security',
                label: 'Security',
                type: 'text',
                name: 'Security-field',
                id: 'Security-field',
            },
            {
                key: 'GeneralContracts',
                label: 'General Contracts',
                type: 'text',
                name: 'GeneralContracts-field',
                id: 'GeneralContracts-field',
            },
        ];
        const rules = {
            formData: {
                LKStatus: { required },
                ID: { required },
                Contract: { required },
                ContractName: { required },
                ContractLevel: { required },
                ContractSubLevel: { required },
                PotentialPositionCategories: { required },
                ContractPosition: { required },
                PensionScheme: { required },
                PensionMaxEE: { required },
                PensionMaxER: { required },
                PensionRule: { required },
                PensionMaxEarningsCap: { required },
                LifeCover: { required },
                PMI: { required },
                Car: { required },
                CarAllowance: { required },
                Bonus: { required },
                OvertimeEligibility: { required },
                OvertimeNote: { required },
                Holidays: { required },
                HolidaysCarryOver: { required },
                ProbationPeriod: { required },
                ASRReviewDate: { required },
                HoursofWork: { required },
                Sickness: { required },
                NoticePeriod: { required },
                PostEmploymentRestrictionsNotwithin3monthofleaving: { required },
                PostEmploymentRestrictionsNotwithin6mthofleaving: { required },
                PostEmploymentRestrictionsNotwithin9mthofleaving: { required },
                ExampleTitles1: { required },
                ContractTitle: { required },
                Security: { required },
                GeneralContracts: { required },
                ContractType: { required },
            },
        };
        const v$ = useVuelidate(rules, { formData });
        const handleCreateContract = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const payload = {
                    type: 'contract',
                    ContractTypeId: props.contractTypeId,
                    ...formData,
                };
                const response = await httpClient.post('/config/create', payload);
                if (response.data.statusCode === 500)
                    throw new Error();
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: props.selectedContract
                        ? 'Changes saved'
                        : 'Successfully created new contract',
                });
                emit('cancel', { refresh: true });
            }
            catch (err) {
                console.log(err);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: props.selectedContract
                        ? 'Error saving changes'
                        : 'Could not create contract',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(() => {
            formData.ContractType = props.contractType || '';
            if (props.selectedContract) {
                Object.assign(formData, props.selectedContract);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(),
                                _createElementVNode("fieldset", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_10, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (item) => {
                                            return _createElementVNode("div", {
                                                key: item,
                                                class: "flex items-center mr-6"
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    id: `LKStatus-${item.toString()}`,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.LKStatus) = $event)),
                                                    value: item,
                                                    name: `LKStatus-${item.toString()}`,
                                                    type: "radio",
                                                    checked: formData.LKStatus === item,
                                                    class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                }, null, 8, _hoisted_11), [
                                                    [_vModelRadio, formData.LKStatus]
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    for: `LKStatus-${item.toString()}`,
                                                    class: "ml-3 block text-sm font-medium text-gray-700"
                                                }, _toDisplayString(item.toString()), 9, _hoisted_12)
                                            ]);
                                        }), 64))
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
                                return _createElementVNode("div", {
                                    key: field.id,
                                    class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
                                }, [
                                    _createElementVNode("label", _hoisted_13, _toDisplayString(field.label), 1),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: field.id,
                                            "onUpdate:modelValue": ($event) => ((formData[field.key]) = $event),
                                            type: field.type,
                                            name: field.name,
                                            class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            disabled: _ctx.selectedContract,
                                            onBlur: ($event) => (_unref(v$).formData[field.key].$touch())
                                        }, null, 40, _hoisted_15), [
                                            [_vModelDynamic, formData[field.key]]
                                        ]),
                                        _createTextVNode(),
                                        (_unref(v$).formData[field.key]?.$error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createElementVNode("p", _hoisted_17, "* " + _toDisplayString(_unref(v$).formData[field.key].$errors[0].$message), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]);
                            }), 64))
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:underline",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('cancel')))
                        }, "Cancel"),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            disabled: _unref(v$).$invalid,
                            type: "submit",
                            class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                            onClick: _withModifiers(handleCreateContract, ["prevent"])
                        }, "Save", 8, _hoisted_20)
                    ])
                ])
            ]));
        };
    }
});
